export type RecordingFormat = "webm" | "mp4";

export const WEBM_MIME_CANDIDATES = ["video/webm;codecs=vp9", "video/webm;codecs=vp8", "video/webm"];
export const MP4_MIME_CANDIDATES = ["video/mp4;codecs=avc1", "video/mp4"];

export function pickSupportedMimeType(format: RecordingFormat): string {
  if (typeof MediaRecorder === "undefined" || typeof MediaRecorder.isTypeSupported !== "function") return "";
  const candidates = format === "mp4" ? MP4_MIME_CANDIDATES : WEBM_MIME_CANDIDATES;
  return candidates.find((type) => MediaRecorder.isTypeSupported(type)) ?? "";
}

export function canRecord(format: RecordingFormat): boolean {
  if (typeof MediaRecorder === "undefined") return false;
  if (format === "webm") return true;
  return pickSupportedMimeType("mp4") !== "";
}
